var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.73 2.015.89-1.54c.245-.428.754-.596 1.134-.377a.74.74 0 0 1 .336.433l1.394 3.859a.93.93 0 0 1-.078.791.93.93 0 0 1-.646.462l-4.038.722a.74.74 0 0 1-.544-.074c-.379-.22-.488-.745-.24-1.172l.791-1.372A5.56 5.56 0 0 0 8.033 3q-.108 0-.214.002a5.5 5.5 0 0 0-2.24.54 5.56 5.56 0 0 0-2.546 2.515 5.48 5.48 0 0 0-.508 3.281c.085.557.257 1.1.508 1.605a5.55 5.55 0 0 0 2.913 2.676 5.52 5.52 0 0 0 4.155-.051 5.54 5.54 0 0 0 3.124-3.469q.001 0 .026-.096a1.001 1.001 0 0 1 1.937.508q-.001.005-.002.005a7.47 7.47 0 0 1-2.05 3.412 7.5 7.5 0 0 1-2.34 1.517 7.5 7.5 0 0 1-5.669 0 7.53 7.53 0 0 1-3.885-3.612 7.5 7.5 0 0 1-.694-2.192 7.6 7.6 0 0 1 .015-2.375c.121-.728.35-1.438.68-2.099a7.57 7.57 0 0 1 3.55-3.465 7.5 7.5 0 0 1 3.072-.701h.193q.525.008 1.044.085a7.5 7.5 0 0 1 2.627.929",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export default ForwardRef;